/**
 * @author vishwadeep.kapoor
 * @Date: 2020-11-09 13:17:12
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-11-09 13:17:12
 */

import styled from 'styled-components';

const CorporateHeader = styled.div`
  background: ${({ theme }) => theme.whiteColor};
  width: 100%;
  border-bottom: #f0f0f0 solid 1px;
  .hide{
    display: none;
  }
ul{
  margin:0px;
  padding:0px;
  text-align: right;
  li{
    display: inline-block;
    margin-left: 20px;
    a{
      color: ${({ theme }) => theme.blackColor};
      letter-spacing: 0px;
      padding:10px;
      font-size: 12px;
      display: block;
      border-bottom: rgba(255, 255, 255, 0.68) solid 2px;
      &:hover{
        text-decoration: none;
        border-bottom: ${({ theme }) => theme.primaryColor} solid 2px;
      }
      &.active{
        border-bottom: ${({ theme }) => theme.primaryColor} solid 2px;
      }
    }
  }
}
`;

export default CorporateHeader;




// WEBPACK FOOTER //
// client/components/CorporateHeader/index.js